(() => {
  if (window.tootoProductHoverZoomInitialized) return;
  window.tootoProductHoverZoomInitialized = true;

  const containerSelector =
    '.tooto-product-information .product-media-container--image';
  const precisePointer = window.matchMedia(
    '(min-width: 1025px) and (hover: hover) and (pointer: fine)'
  );
  let activeContainer = null;

  const resetContainer = (container) => {
    if (!container) return;

    container.removeAttribute('data-tooto-hover-zoom-active');
    container.style.removeProperty('--tooto-hover-zoom-x');
    container.style.removeProperty('--tooto-hover-zoom-y');
  };

  const handlePointerMove = (event) => {
    if (!precisePointer.matches || !(event.target instanceof Element)) return;

    const container = event.target.closest(containerSelector);
    if (!container) {
      resetContainer(activeContainer);
      activeContainer = null;
      return;
    }

    if (activeContainer !== container) {
      resetContainer(activeContainer);
      activeContainer = container;
    }

    const bounds = container.getBoundingClientRect();
    if (!bounds.width || !bounds.height) return;

    const x = Math.min(100, Math.max(0, ((event.clientX - bounds.left) / bounds.width) * 100));
    const y = Math.min(100, Math.max(0, ((event.clientY - bounds.top) / bounds.height) * 100));

    container.style.setProperty('--tooto-hover-zoom-x', `${x}%`);
    container.style.setProperty('--tooto-hover-zoom-y', `${y}%`);
    container.setAttribute('data-tooto-hover-zoom-active', '');
  };

  const handlePointerOut = (event) => {
    if (!(event.target instanceof Element)) return;

    const container = event.target.closest(containerSelector);
    if (!container || (event.relatedTarget instanceof Node && container.contains(event.relatedTarget))) return;

    resetContainer(container);
    if (activeContainer === container) activeContainer = null;
  };

  document.addEventListener('pointermove', handlePointerMove, { passive: true });
  document.addEventListener('pointerout', handlePointerOut, { passive: true });
  window.addEventListener('blur', () => {
    resetContainer(activeContainer);
    activeContainer = null;
  });
})();
